import { Image } from "#/api/fileStore.type";
import { MessageRow } from "../../api/message.type";
import MarkdownRenderer from "../shared/markdown/render-md";
import Typography from "../shared/typography";
import { formatTimeStampToHumanReadableDateTimeSeconds } from "../utls/time";
import { cn } from "../utls/utils";
import { ImageCarousel } from "./image-carousel";

function AssistantChatItem({ message }: { message: MessageRow }) {
  // Transform message_file_store data to the format expected by ImageCarousel
  const images =
    (message?.message_file_store?.map((fs) => ({
      url: fs.file_store.url,
      fileName: fs.file_store.name,
      fileType: fs.file_store.type || "image/jpeg", // Assuming images if not specified
    })) as Image[]) || [];

  const hasImages = images.length > 0;

  return (
    <div className="flex items-start">
      <div
        className={cn(
          "max-w-full sm:max-w-[80%] rounded-lg p-4",
          "bg-cream-100 border border-beige-300", // Updated to use Harper brand colors
          "shadow-sm"
        )}
      >
        {/* Display text content if any */}
        {message.content && <MarkdownRenderer content={message.content} />}

        {/* Display image carousel if there are images */}
        {hasImages && (
          <div
            className={cn(
              "mt-3",
              message.content ? "pt-2 border-t border-beige-400" : ""
            )}
          >
            <ImageCarousel size="small" images={images} />
          </div>
        )}

        {/* Timestamp */}
        <Typography
          variant="caption"
          className="text-brown-500 mt-2 block text-right"
        >
          {formatTimeStampToHumanReadableDateTimeSeconds(message.created_at)}
        </Typography>
      </div>
    </div>
  );
}

export default AssistantChatItem;
